import { Constants } from '@utils/constants';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageQuoteQuery } from '@model/webFeeder/message-quote-query.model';
import { Subject , of } from 'rxjs';

@Component({
  selector: 'app-asset-input-header',
  templateUrl: './asset-input-header.component.html',
})
export class AssetInputHeaderComponent implements OnInit {

  msgInvalidAsset = Constants.WORKSPACE_MSG007;
  @Input() symbolAutoComplete: string;
  @Input() reset: Subject<boolean>;
  @Input() lastTrade: string;
  @Input() coinVariation: number;
  @Input() showVariation: boolean;
  @Input() hiddenInvalid: boolean;
  @Input() variation: number;
  @Input() company: string;
  @Input() image: string;
  @Input() showLastTrade = true;
  @Input() dateLastNegotiation: string;
  @Input() hourLastTrade: Date;
  @Input() timeUpdate: string;
  @Input() focusDelay = 500;
  @Output() onsymbolChanged = new EventEmitter<MessageQuoteQuery>();

  constructor() { }

  ngOnInit() { }

  selectAsset(msg: MessageQuoteQuery) {
    this.onsymbolChanged.emit(msg);
  }

}
